module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-clinic-w-c087c02d830af7ffd457a81ce099ba1a.svg";